export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/worker_job_title/queue',
      method: 'GET'
    }]
  },
  queue: {
    funKey: 'queue',
    name: '排队情况'
  }
}